import React from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Button,
  Link as MuiLink,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { BASE_URL } from "../../Utils/Baseurl";

const isImage = (url) => {
  return /\.(jpeg|jpg|gif|png|webp)$/i.test(url);
};

const ViewAllTask = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state?.data;

  if (!data) {
    return (
      <DashboardLayout>
        <Box p={4} textAlign="center">
          <Typography variant="h6">No task data found.</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box p={4}>
        {/* Back Button */}
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
        >
          Back
        </Button>

        <Card elevation={3}>
          <CardContent>
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Task Details
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><Typography><strong>Project:</strong> {data.project_name}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Task Code:</strong> {data.task_code}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Title:</strong> {data.task_title}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Status:</strong> {data.status}</Typography></Grid>
              <Grid item xs={12}><Typography><strong>Description:</strong> {data.task_describtion}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Team:</strong> {data.team_name}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Assignee:</strong> {data.assignee_name}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Created By:</strong> {data.task_creater_name}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Stakeholders:</strong> {data.stake_holder.map(s => s.user_name).join(", ")}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Start Date:</strong> {data.start_date}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>End Date:</strong> {data.end_date}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Actual Start Date:</strong> {data.actual_start_date}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Actual End Date:</strong> {data.actual_end_date}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Assigned Hours:</strong> {data.assigned_hours}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Actual Hours:</strong> {data.actual_hours ?? "N/A"}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Priority:</strong> {data.priority_level}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Module:</strong> {data.module}</Typography></Grid>
              <Grid item xs={12} sm={6}><Typography><strong>Sprint:</strong> {data.sprint_number}</Typography></Grid>
            </Grid>

            {data.attachment && (
              <Box mt={4}>
                <Typography variant="subtitle1" gutterBottom><strong>Attachment:</strong></Typography>
                {isImage(data.attachment) ? (
                  <Avatar
                    variant="rounded"
                    src={`${BASE_URL}${data.attachment}`}
                    alt="Task Attachment"
                    sx={{ width: 200, height: 200 }}
                  />
                ) : (
                  <MuiLink
                    href={`${BASE_URL}${data.attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    display="flex"
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <InsertDriveFileIcon sx={{ mr: 1 }} />
                    Download Attachment
                  </MuiLink>
                )}
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    </DashboardLayout>
  );
};

export default ViewAllTask;
